/**
 * Mutation Types for all moduless
 */


export const USER_SET_LOGIN_STATUS = 'user/SET login status';
export const USER_SET_USER = 'user/SET user info';
export const USER_SET_ERROR = 'user/SET error';
export const USER_SET_INIT = 'user/SET user login init';

export const SUBMISSION_SET_MADE = 'submision/SET that user made a submission';
export const SUBMISSION_SET_SHARE_URL = 'submision/SET submission share urls';
export const SUBMISSION_SET_COMPLETE = 'submission/SET submission flag as complete';
export const SUBMISSION_SET_LAST_CALL = 'submission/SET last call reference';
export const SUBMISSION_SET_ID = 'submission/SET submission id';
export const SUBMISSION_SET_STATUS = 'submission/SET submission status';
export const SUBMISSION_SET_ERROR = 'submission/SET error';
export const SUBMISSION_SET_PROGRESS = 'submission/SET progress';
export const SUBMISSION_SET_THUMBNAIL = 'submission/SET thumbnail';
export const SUBMISSION_DELETE_THUMBNAIL = 'submission/DELETE thumbnail';
export const SUBMISSION_SET_SHARE_PATH = 'submission/SET path for share links';

export const SUBMISSION_VIEW_SET_ERROR = 'submissionView/SET fetch error';
export const SUBMISSION_VIEW_SET_LAST_CALL = 'submissionView/SET last call reference';
export const SUBMISSION_VIEW_SET_LAST_PAGE_CALL = 'submissionView/SET last call reference';
export const SUBMISSION_VIEW_SET_ACTIVE_SUBMISSION_ID = 'submissionView/SET the submission focused';
export const SUBMISSION_VIEW_SET_ACTIVE_PAGE_INDEX = 'submissionView/SET the submission page';
export const SUBMISSION_VIEW_CLEAR_ACTIVE_SUBMISSION_ID = 'submissionView/CLEAR the submission focused';
export const SUBMISSION_VIEW_SET_LIGHTBOX_EXPANDED = 'submissionView/Set the lightbox to open or closed';
export const SUBMISSION_VIEW_UPDATE_SUBMISSIONS_VISIBLE = 'submissionView/UPDATE the visible submission ids';
export const SUBMISSION_VIEW_UPDATE_SUBMISSIONS_MAP = 'submissionView/UPDATE the map of submissions';
export const SUBMISSION_VIEW_SET_MORE_SUBMISSIONS = 'submissionView/SET if there are no more submissions';
export const SUBMISSION_VIEW_SET_NEXT_RESULTS_PAGE = 'submissionView/SET the next page to load for results';
export const SUBMISSION_VIEW_SET_SUBMISSION_REPORTED = 'submissionView/SET that this submission was reported this session';

export const UI_SET_ENTRY_VIEW = 'ui/SET entry view active';
export const UI_HERO_VIDEO_VISIBLE = 'ui/SET if the hero video is visible';

export const WINDOW_MEDIA_SET_DEVICE_TYPE = 'windowMedia/SET device type';
export const WINDOW_MEDIA_SET_OS = 'windowMedia/SET device OS';
export const WINDOW_MEDIA_SET_BROWSER = 'windowMedia/SET browser type';
export const WINDOW_MEDIA_SET_SIZE = 'windowMedia/SET viewport size';
export const WINDOW_MEDIA_SET_MEDIA_XLARGE = 'windowMedia/SET media is it X large';
export const WINDOW_MEDIA_SET_MEDIA_LARGE = 'windowMedia/SET media is it large';
export const WINDOW_MEDIA_SET_MEDIA_MEDIUM = 'windowMedia/SET media is it medium';
export const WINDOW_MEDIA_SET_MEDIA_SMALL = 'windowMedia/SET media is it small';
export const WINDOW_MEDIA_SET_SCROLL_TOP = 'windowMedia/SET scrollTop';
